import { NgModule } from '@angular/core';
import { GtmGgSearchPageEventBuilder } from './gtm-gg-search-page-event.builder';

@NgModule({})
export class GtmGgSearchPageEventModule {
  constructor(_gtmGgSearchPageEventBuilder: GtmGgSearchPageEventBuilder) {}
}
